import { formatarPrecoDePlano } from '@/shared/formatters/currency';

import type { PlanoNegociacaoCard, PlanoNegociacaoSelf } from '../types';

/**
 * Card de plano da tela de pagamento a partir do catálogo do core: os três itens de recurso
 * descrevem a tabela de 2026-11 (franquia, envio extra e taxa por acordo), no lugar do texto
 * fixo dos planos antigos.
 *
 * @example toPlanoNegociacaoCard(pro).recursos // ['Até 150 envios por mês', '+R$ 7,00 por envio extra', 'Taxa de êxito: R$ 49 por acordo fechado']
 */
export const toPlanoNegociacaoCard = (plano: PlanoNegociacaoSelf): PlanoNegociacaoCard => ({
  variationId: plano.variationId,
  nome: plano.nome,
  preco: formatarPrecoDePlano(plano.precoMensal),
  recursos: [
    `Até ${plano.franquiaEnvios.toLocaleString('pt-BR')} envios por mês`,
    plano.porEnvio,
    ...(plano.taxaExito
      ? [`Taxa de êxito: ${formatarPrecoDePlano(plano.taxaExito)} por acordo fechado`]
      : []),
  ],
  recomendado: plano.destaque,
});

/** "Plano Pro • R$ 799/mês · cobrança mensal" — resumo das telas de espera e de sucesso. */
export const resumoDoPlano = (plano: PlanoNegociacaoSelf | null): string =>
  plano
    ? `Plano ${plano.nome} • ${formatarPrecoDePlano(plano.precoMensal)}/mês · cobrança mensal`
    : '';
